import { dispatchPromise } from './action-helpers';

export const fetchUserState = () => {
    return dispatchPromise({
        type: 'USER_STATE_FETCH_REQUESTED',
        payload: {}
    });
}

export const updateChatsUserState = ({ visible }) => {
    return dispatchPromise({
        type: 'USER_STATE_CHATS_UPDATE_REQUESTED',
        payload: {
            visible
        }
    });
}

export const updateSubteamsUserState = ({ collapsed }) => {
    return dispatchPromise({
        type: 'USER_STATE_SUBTEAMS_UPDATE_REQUESTED',
        payload: {
            collapsed
        }
    });
}

export const updateProjectUserState = (projectId, projectState) => {
    return dispatchPromise({
        type: 'USER_STATE_PROJECT_UPDATE_REQUESTED',
        payload: {
            projectId,
            projectState
        }
    });
}

export const updateProjectTasksUserState = (projectId, projectTasksState) => {
    return dispatchPromise({
        type: 'USER_STATE_PROJECT_TASKS_UPDATE_REQUESTED',
        payload: {
            projectId,
            projectTasksState
        }
    });
}

export const updateAllTasksUserState = ({ collapsedGroups, hiddenColumns, columns }) => {
    return dispatchPromise({
        type: 'USER_STATE_ALL_TASKS_UPDATE_REQUESTED',
        payload: {
            tasks: {
                collapsedGroups,
                hiddenColumns,
                columns
            }
        }
    });
}

export const updateMyTasksUserState = ({ collapsedGroups, hiddenColumns, columns }) => {
    return dispatchPromise({
        type: 'USER_STATE_MY_TASKS_UPDATE_REQUESTED',
        payload: {
            tasks: {
                collapsedGroups,
                hiddenColumns,
                columns
            }
        }
    });
}

export const updateWorkloadsState = ({ type, start, end }) => {
    return dispatchPromise({
        type: 'USER_STATE_WORKLOADS_UPDATE_REQUESTED',
        payload: {
            type,
            start,
            end
        }
    });
}
